import { render, staticRenderFns } from "./CarouselAdmin.vue?vue&type=template&id=7d0fc138&scoped=true"
import script from "./CarouselAdmin.vue?vue&type=script&lang=js"
export * from "./CarouselAdmin.vue?vue&type=script&lang=js"
import style0 from "./CarouselAdmin.vue?vue&type=style&index=0&id=7d0fc138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0fc138",
  null
  
)

export default component.exports